import { ModalMessage } from '@zorro/design-system/v2/ModalMessage';

type Props = {
  isOpen: boolean;
  /** Named in the question so the viewer knows which document is going. */
  fileName?: string;
  onConfirm: () => Promise<void>;
  onClose: () => void;
};

/**
 * The one delete confirmation for document cards, so every surface asks the
 * same question in the same words.
 */
export const DocumentDeleteModal = ({
  isOpen,
  fileName,
  onConfirm,
  onClose,
}: Props) => (
  <ModalMessage
    isOpen={isOpen}
    onClose={onClose}
    variant="negative"
    title="Delete document"
    description={`Are you sure you want to delete ${fileName || 'this document'}?`}
    primaryLabel="Delete document"
    onPrimaryAction={onConfirm}
    secondaryLabel="Cancel"
    onSecondaryAction={onClose}
  />
);
